<template>
  <div class="home">
    <top-navigation ref="topNav"
                    navBg="#fff"
                    :isHome="false"></top-navigation>
    <div style="height:75px"></div>
    <el-image v-if="swiperList && swiperList.length!=0"
              style="min-width: 1200px;height:463px;"
              @click="$Public.link(swiperList[0])"
              :src="swiperList[0].resourceUrl + '?imageMogr2/thumbnail/100000000@'"
              alt=""></el-image>
    <div class="tech_box">
      <div class="currency_boxs">
        <tech-item :list="techProductList"></tech-item>
        <div class="flexCenter"
             style="margin: 0 0 10px 0;">
          <el-pagination background
                         @current-change="currentChange"
                         layout="prev, pager, next"
                         :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  techProductPage, resourceList
} from '@/api/api.js'
import techItem from '../../../components/techProduct/tech-item.vue';
export default {
  components: { techItem },
  data () {
    return {
      total: 0,
      swiperList: [],
      formData: {
        pageNum: 1,
        pageSize: 12
      },
      techProductList: []
    }
  },
  created () {
    this.postList();
    this.getresourceList(43)
  },
  methods: {
    async getresourceList (type) {  //获取首页资源
      const res = await resourceList({ showIndex: type })
      console.log(res)
      if (res && res.data) {
        let list = res.data;
        this.swiperList = list;
      }

    },
    currentChange (e) {
      console.log(e)
      this.formData.pageNum = e;
      this.postList();
    },
    postList () {
      techProductPage(this.formData).then(res => {
        console.log(res)
        if (res.code <= 200) {
          const { records, total } = res.data;
          this.techProductList = records;
          this.total = Number(total)
          // Number(total)
        }
      })
    }
  }
}
</script>